var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    height: 6,
    id: "screenshot-0bd5c767-32dc-80ef-8007-619f9c21ffea",
    viewBox: "187 3255 10 6",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-0bd5c767-32dc-80ef-8007-619f9c21ffea",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-0bd5c767-32dc-80ef-8007-619f9c21ffeb"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-0bd5c767-32dc-80ef-8007-619f9c21ffeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.023681640625,3255L197,3258.022705078125L194.068603515625,3261"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8ad3ba-c440-8062-8007-7dc1462a88de-0bd5c767-32dc-80ef-8007-619f9c21ffeb",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.023681640625,3255L197,3258.022705078125L194.068603515625,3261",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1.5,
      stroke: "#fff",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-0bd5c767-32dc-80ef-8007-619f9c21ffec"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-0bd5c767-32dc-80ef-8007-619f9c21ffec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,3257.998046875L194.6285400390625,3257.998046875L197,3257.998046875L197,3257.998046875L197,3257.998046875"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8ad3ba-c440-8062-8007-7dc1462a88df-0bd5c767-32dc-80ef-8007-619f9c21ffec",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,3257.998046875L194.6285400390625,3257.998046875L197,3257.998046875L197,3257.998046875L197,3257.998046875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1.5,
      stroke: "#fff",
      strokeOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.959587b6daf43c90dccdaadd43d9f24a.svg";
export { ForwardRef as ReactComponent };